import React, {useContext, useEffect, useState} from 'react';
import {Box, Grid, ListItem, IconButton, Tooltip, Typography, useToastProvider} from '@deere/fuel-react';
import {toDisplayName} from "../shared/utils";
import {useAuthConfig} from "../shared/helper";
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {CHANGE_COMMENT_VISIBLE} from "../shared/Constants";
import {RolesContext, UnitsContext} from "./Ratings";

export const RatingsGeneralComments = ({
                                           feedback,
                                           itemIndex,
                                           commentData,
                                           isActionsAllowed,
                                           isAddCommentOpen,
                                           isEditCommentOpen,
                                           updateVisibilityState,
                                            isSupplierMimic
                                       }) => {
    let authAxios = useAuthConfig();
    const {enqueueToast} = useToastProvider();
    const [rolesArr, setRolesArr] = useState([])
    const [unitsArr, setUnitsArr] = useState([])
    const [rolesArrString, setRolesArrString] = useState("")
    const [unitsArrString, setUnitsArrString] = useState("")

    const name = toDisplayName(feedback?.user?.firstName || '', feedback?.user?.lastName || '')
    const [commentVisibility, setCommentVisibility] = useState(commentData[0].isCommentVisible);
    const units = useContext(UnitsContext);
    const roles = useContext(RolesContext);

    const handleVisibility = (period, supplierNumber, commentId, feedbackId, categoryId, visibilityInd) => {
        let putData = {
            period: period,
            supplierNumber: supplierNumber,
            commentId: commentId,
            feedbackId: feedbackId,
            criteriaId: null,
            visibilityInd: visibilityInd,
            categoryId: categoryId,
            responseType: 2,
            id: categoryId
        }
        authAxios.put(`/commentsVisibility`, putData)
            .then(res => {
                updateVisibilityState("generalComment-visibility", res.data)
                setCommentVisibility(res.data.visibilityInd)
                enqueueToast({
                    variant: "success",
                    title: "General Comment Updated Successfully",
                    isCloseable: true
                });
            }).catch((e) => {
            console.error(e);
            enqueueToast({
                variant: "error",
                title: "Error updating comment visibility",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        })
    }

    useEffect(() => {
        const tempRolesArr = feedback.roleId.map(item => {
            const filteredArr = roles.filter(ele => ele.id === item)
            return filteredArr.length > 0 && filteredArr[0]["description"]
        })
        const tempUnitsArr = feedback.unitId.map(item => {
            const filteredArr = units.filter(ele => ele.id === item)
            return filteredArr.length > 0 && filteredArr[0]["description"]
        })
        setRolesArr(tempRolesArr)
        setUnitsArr(tempUnitsArr)
        setRolesArrString(tempRolesArr.length !== 0 && tempRolesArr.join(', '))
        setUnitsArrString(tempUnitsArr.length !== 0 && tempUnitsArr.join(', '))
        return () => {
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [feedback])

    return (
        <>
            {((isActionsAllowed && !isSupplierMimic) || ((!isActionsAllowed || isSupplierMimic) && commentVisibility)) &&
            <ListItem divider style={{padding: '.5rem 0rem'}}
                      key={itemIndex}>
                <Grid container alignItems="center">
                    {(isActionsAllowed && !isSupplierMimic) && (
                        <Grid item xs={1} style={{maxWidth: '5%'}}>
                            {commentVisibility ?
                                <Tooltip
                                    title={CHANGE_COMMENT_VISIBLE}
                                    placement="bottom-start"
                                >
                                    <IconButton aria-label="visibility" onClick={() => {
                                        handleVisibility(commentData[0].year,
                                            feedback.supplierNumber,
                                            commentData[0].commentId,
                                            commentData[0].feedbackId,
                                            commentData[0].categoryId,
                                            false)
                                    }}>
                                        <VisibilityIcon style={{color: " #367c2b"}}/>
                                    </IconButton>
                                </Tooltip>
                                :
                                <Tooltip
                                    title={CHANGE_COMMENT_VISIBLE}
                                    placement="bottom-start"
                                >
                                    <IconButton aria-label="visibility_hide" onClick={() => {
                                        handleVisibility(commentData[0].year,
                                            feedback.supplierNumber,
                                            commentData[0].commentId,
                                            commentData[0].feedbackId,
                                            commentData[0].categoryId,
                                            true)
                                    }}>
                                        <VisibilityOffIcon style={{color: "#ccc"}}/>
                                    </IconButton>
                                </Tooltip>
                            }
                        </Grid>
                    )}
                    <Grid item xs={(isActionsAllowed && !isSupplierMimic) ? 11 : 12}
                          style={((isActionsAllowed && !isSupplierMimic)) ? {
                              maxWidth: '95%',
                              flexBasis: '95%'
                          } : (!isActionsAllowed || isSupplierMimic) ? {paddingLeft: '2rem'} :
                              ((isActionsAllowed && !isSupplierMimic)) ? {
                                  paddingRight: ".5rem",
                                  maxWidth: '95%',
                                  flexBasis: '95%'
                              } : {
                                  paddingRight: ".5rem",
                                  paddingLeft: "2rem"
                              }}>
                        <Grid container alignItems="center">
                            <Grid item xs={8}>
                                <Box display="flex"
                                     justifyContent="flex-start">
                                    {commentVisibility ?
                                        <Typography color="primary">
                                            {commentData[0].comment}
                                        </Typography>
                                        :
                                        <Typography color="tertiary">
                                            {(isActionsAllowed && !isSupplierMimic) ? commentData[0].comment : ""}
                                        </Typography>
                                    }
                                </Box>
                            </Grid>
                            <Grid item xs={4}/>
                            <Grid item xs={8}>
                                <Box display="flex" justifyContent="flex-start">
                                    {rolesArrString.concat(name).length > 90 ?
                                        <Tooltip
                                            title={rolesArrString}
                                            placement="bottom-start"
                                        >
                                            <Typography color="secondary" size="sm" style={{
                                                width: 500,
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                overflow: "hidden"
                                            }}>
                                                {name} | {rolesArr.join(', ')}
                                            </Typography>
                                        </Tooltip>
                                        :
                                        <Typography color="secondary" size="sm">
                                            {name} | {rolesArr.join(', ')}
                                        </Typography>
                                    }
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                <Box display="flex" justifyContent="flex-end">
                                    {unitsArrString && unitsArrString.concat(commentData[0].year).length >= 40 ?
                                        <Tooltip
                                            title={unitsArrString}
                                            placement="bottom-start"
                                        >
                                            <Typography color="secondary" size="sm" style={{
                                                width: 250,
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                overflow: "hidden"
                                            }}>
                                                {commentData[0].year ? `${commentData[0].year}` : ""} {commentData[0].year && unitsArr.length !== 0 ? "|" : ""} {" "}{unitsArrString}
                                            </Typography>
                                        </Tooltip>
                                        :
                                        <Typography color="secondary" size="sm">
                                            {commentData[0].year ? `${commentData[0].year}` : ""} {commentData[0].year && unitsArr.length !== 0 ? "|" : ""} {" "}{unitsArrString}
                                        </Typography>
                                    }
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </ListItem>
            }
        </>
    )
}
